import { Button } from "antd";
import { type MouseEvent, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext";
import { useMarkAsReadNotification } from "~pages/Notifications/hooks/useMarkAsReadNotification";
import type { Notification } from "~types/notification";

type Props = {
  notification: Notification;
};

const DownloadButton = ({ notification }: Props) => {
  const { mutateAsync: markAsRead } = useMarkAsReadNotification();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  const handleDownload = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      if (notification.unread) {
        markAsRead(notification.key);
      }
      refetchUserUpdates();
    },
    [notification, markAsRead, refetchUserUpdates],
  );

  return (
    <Button
      type="primary"
      size="small"
      href={notification.data.DownloadUrl}
      rel="noopener noreferrer"
      onClick={handleDownload}
      style={{ marginTop: "8px", textDecoration: "none", textTransform: "none" }}
    >
      <FormattedMessage id="download" />
    </Button>
  );
};

export default DownloadButton;
